import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const appReport = "app-report/";
const login = "login/";
const market = "market/";
const postLoginUrl = {
    positions: config.jmwedel + config.equity + "positions/net/interop",
    saveIndices: config.jmwedel + config.equity + "client-details/save-indices",
    portfolioComposition: config.jmwedel +
        config.reportBase +
        appReport +
        login +
        "dashboard/sector-wise",
    contribution: config.jmwedel +
        config.reportBase +
        appReport +
        login +
        "dashboard/contribution",
    indexList: config.jmwedel + config.reportBase + config.equity + "client-details",
    marketMapPostLogin: config.jmwedel + config.reportBase + appReport + market + "map",
    serviceList: config.jmwedel + config.jmw_login + "sr/servicelist",
    exploreTrade: config.jmwedel +
        config.revamp +
        config.jmw_eq +
        "client-details/disable-explore-trade",
    diversifyPortfolio: config.jmwedel + appReport + login + "dashboard/diversify-portfolio",
    upcomingEvents: config.jmwedel + config.reportBase + appReport + login + "dashboard/events",
    allIndicesList: config.jmwedel + config.jmw_content + "indexlist/bull",
    nfoLive: config.jmwedel + config.jmw_content + "nfo/live",
};
export default postLoginUrl;
